/**
 * Builds a CSV string for Instantly re-import: original Estage columns
 * plus a `tryout_url` column at the end.
 */

export interface ExportableToken {
  lead_email: string | null;
  lead_first_name: string | null;
  crm_lead_name: string | null;
  crm_lead_company: string | null;
  location: string | null;
  bundesland: string | null;
  berufsgruppe: string | null;
  personalization_original: string | null;
  campaign_name: string | null;
  tryout_url: string;
}

const HEADERS = [
  'Kampagnenname', 'E-Mail', 'Vorname', 'Nachname',
  'companyName', 'location', 'custom1', 'custom2',
  'personalization', 'tryout_url',
] as const;

function csvEscape(v: string | null | undefined): string {
  if (v == null) return '';
  if (/[",\n;]/.test(v)) return `"${v.replace(/"/g, '""')}"`;
  return v;
}

function splitFullName(full: string | null): { first: string; last: string } {
  if (!full) return { first: '', last: '' };
  const parts = full.trim().split(/\s+/);
  if (parts.length === 1) return { first: parts[0], last: '' };
  return { first: parts[0], last: parts.slice(1).join(' ') };
}

export function buildInstantlyExportCsv(tokens: ExportableToken[]): string {
  const lines: string[] = [HEADERS.join(',')];
  for (const t of tokens) {
    const { first, last } = splitFullName(t.crm_lead_name);
    const firstName = t.lead_first_name || first;
    lines.push([
      csvEscape(t.campaign_name),
      csvEscape(t.lead_email),
      csvEscape(firstName),
      csvEscape(last),
      csvEscape(t.crm_lead_company),
      csvEscape(t.location),
      csvEscape(t.bundesland),
      csvEscape(t.berufsgruppe),
      csvEscape(t.personalization_original),
      csvEscape(t.tryout_url),
    ].join(','));
  }
  return lines.join('\n') + '\n';
}
